<template>
  <item-nav :id="$attrs['id']">
    <item-nav-item :label="$t('layout.nav.admin.seasonCalendarNav.overview')" link="seasonCalendars" />
    <item-nav-item :params="routeParams('DayRate')" :key="'DayRate'" :label="$t('layout.nav.admin.seasonCalendarNav.ratePlanSeasonCalendar')" link="seasonCalendar" />
    <item-nav-item v-if="hasLicense('Packages')"
                   :params="routeParams('Package')"
                   :key="'Package'"
                   :label="$t('layout.nav.admin.seasonCalendarNav.packageSeasonCalendar')"
                   link="seasonCalendar" />
  </item-nav>
</template>

<script>

import { cloneDeep, isNil, isEmpty } from 'lodash';
import ItemNavGroup from '../ItemNavGroup';
import ItemNavGroupItem from '../ItemNavGroupItem';
import HotelmeisterMixin from '../../../../../mixins/HotelmeisterMixin';

export default {
  name: 'SeasonCalendarNav',
  components: { ItemNavGroupItem, ItemNavGroup },

  mixins: [HotelmeisterMixin],
  props: [],

  data() {
    return {
    };
  },

  computed: {
  },

  created: function () {
  },

  mounted: function () {
    this.$emit('widenav', true);
  },

  methods: {
    routeParams(ratePlanType) {
      return {
        ratePlanType: ratePlanType,
      };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // @import '~styles/main';
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/admin/SeasonCalendarNav.vue